export default __webpack_public_path__ + "2b02ebe9cb7f90fdff871256a63df805.png";